export default `
  mutation deleteOrganisation($id: String!) {
    deleteOrganisation(id: $id) {
        id
    }
  }
`
